export const SCROLL_ANIMATION_DEFAULT_NAME = 'Action'
export const SCROLL_ANIMATION_DEFAULT_NAME_MOBILE = 'Action_Mobile'
export const SCROLL_ANIMATION_DEFAULT_NAME_DESKTOP = 'Action_Desktop'

export const SCROLL_SPEED = 0.0145;
export const MOBILE_SPEED_MULTIPLIER = 0.2;

export const SCROLL_CAMERA_DEFAULT_NAME = 'Camera';
export const SCROLL_CAMERA_DEFAULT_MOBILE_NAME = 'Camera_Mobile';
export const SCROLL_CAMERA_DEFAULT_DESKTOP_NAME = 'Camera_Desktop';
// Camera rotation control constants
export const FORWARD_BACKWARD_KEYS = ['w', 's', 'arrowup', 'arrowdown']; // Keys for forward/backward movement when rotateCameraTowardsMovementDirection is enabled
export const DEFAULT_CAMERA_ROTATION_SPEED = 2; // Radians per second
export const DEFAULT_JOYSTICK_ROTATION_SENSITIVITY = 30;
